import React, { Component } from 'react';
import Row from '../Row';
import Col from '../Col';
import './HomeOwnerDashboard.scss';
import Empty from '../Empty';
import EmptyImage from './EmptyImage';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { PATHS } from '../../common/constants';
import FontAwesomeIcon from '../Icon';
import { setAnnouncementFormData, clearAnnouncementFormData } from '../../store/actions/AnnouncementForm';
import Overlay from '../Overlay';
import Announcementsview from '../../pages/Announcements/Announcementsview';


class MessagesList extends Component {
    constructor() {
        super()
        this.state = {
            showOverlay: false,
            announcementData: {}
        }
    }
    render() {
        const { data, currentUserSuite } = this.props;        
        const { datta } = this.props;
        const { showOverlay } = this.state;
        return (
            <div className='homeDasboard__mainTile'>
                <div style={{ padding: 20 }}>
                    {/* <label className='homeDasboard__title'>MESSAGES {localStorage.getItem('theme') !== 'Shape' && '& ANNOUNCEMENTS'}</label> */}
                    <label className='homeDasboard__title'>MESSAGES & ANNOUNCEMENTS</label>
                    {data && data.length || datta && datta.length > 0 ?
                        <div className='homeDasboard__tile'>
                            <div style={{ display: 'flex' }}>
                                <div style={{ width: '30%' }}>
                                    <div className='homeDasboard__tableItem'>Date</div>
                                </div>
                                <div>
                                    <div className='homeDasboard__tableItem'>Messages/description </div>
                                </div>
                            </div>
                            <div className='homeDasboard__list'>

                                {data && data.map((msgObj, i) => {
                                    return (
                                        <Link
                                            to={msgObj.referenceType === 'Suite' ? {
                                                pathname: PATHS.SUITES_VIEW.replace(':id', currentUserSuite.propertyId + "&" + msgObj.referenceId),
                                                state: { suite: { id: msgObj.referenceId }, property: { id: currentUserSuite.propertyId }, activeTab: 3,from:'Dashboard' }
                                            } :
                                                {
                                                    pathname: PATHS.SERVICE_REQUESTS_VIEW.replace(':id', msgObj.referenceId),
                                                    state: { activeTab: 1 }
                                                }}
                                        >
                                            <div className='homeDasboard__table' key={i} >
                                                <div style={{ display: 'flex' }}>
                                                    <div style={{ width: '30%' }}>

                                                        <label className='homeDasboard__activityText'>{moment(msgObj.sentOn).format('MM/DD/YYYY')}</label>
                                                    </div>
                                                    <div style={{ width: '70%' }}>
                                                        <div className='homeDasboard__date' >{msgObj.sentByName}</div>
                                                        <div className='homeDasboard__role'>{msgObj.message}</div>
                                                        <div className='homeDasboard__reply' style={{ display: 'flex', width: '100%' }}>
                                                            <div className='homeDasboard__role'>{msgObj.description}</div>
                                                            <div className='homeDasboard__tableItem' style={{ width: '75%' }}>REPLY</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>

                                    )
                                })}
                                {datta && datta.map((msgobj, i) => {

                                    return (
                                        <Link
                                            //to={{pathname: PATHS.ANNOUNCEMENTS_VIWE.replace(':id', msgobj.id), state: {data: msgobj}}}
                                            onClick={() => this.setState({ showOverlay: true, announcementData: msgobj })}
                                        >
                                            <div className='homeDasboard__table' key={i} >
                                                <div style={{ display: 'flex' }}>
                                                    <div style={{ width: '30%' }}>

                                                        <label className='homeDasboard__activityText'>{moment(msgobj.announcementDate).format('MM/DD/YYYY')}</label>
                                                    </div>

                                                    <div style={{ width: '70%' }}

                                                    >


                                                        <div style={{ width: '70%', display: "flex", justifyContent: "space-between" }}> <div className='homeDasboard__rol'> 
                                                        {/* <div dangerouslySetInnerHTML={{__html:msgobj.description }} />  */}
                                                        {msgobj.description.replace(/<[^>]+>/g, '')}
                                                        </div>
                                                            <div className="homeDasboard__icon"  > <FontAwesomeIcon glyph="bullhorn" weight="solid" size="small" /></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>

                                    )
                                })} </div>
                        </div>
                        :
                        <EmptyImage
                            width={230}
                            height={140}
                            text='You have no messages.'
                            image={"/assets/empty/notes.svg"}
                        />
                    }
                </div>
                <Overlay
                    showOverlay={showOverlay}
                    content={(
                        <Announcementsview
                            data={this.state.announcementData}
                            onClose={() => {
                                this.setState({ showOverlay: false })
                            }}
                        />
                    )}
                />
            </div>

        )
    }
}
export default MessagesList